import { render, staticRenderFns } from "./button-groups.vue?vue&type=template&id=779223c4&"
import script from "./button-groups.vue?vue&type=script&lang=js&"
export * from "./button-groups.vue?vue&type=script&lang=js&"
import style0 from "./button-groups.vue?vue&type=style&index=0&id=779223c4&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports